import type { ReactNode } from 'react';
import { PageContainer } from '../PageContainer/PageContainer';
import { SplitLayout } from '../layouts/SplitLayout';

export type SideNavTemplateProps = {
  /** A SideNav (ink for the current page). */
  nav: ReactNode;
  /** A PageHeader. */
  header: ReactNode;
  /** InlineAlerts for results ("Saved", "Key created"). */
  notices?: ReactNode;
  children: ReactNode;
  className?: string;
};

/**
 * Pages with section navigation: settings and the employer portal (SettingsTemplate), the profile
 * and CV Studio (ProfileCvTemplate: a readiness Progress with a checklist, the document preview,
 * one primary action).
 */
export function SideNavTemplate({ nav, header, notices, children, className }: SideNavTemplateProps) {
  return (
    <PageContainer width="wide" className={className}>
      <div className="py-jc-block">
        <SplitLayout aside={nav} asidePosition="left" asideWidth="toc" stickyAside asideFirstOnPhones>
          <div className="flex max-w-4xl flex-col gap-jc-block">
            {header}
            {notices}
            {children}
          </div>
        </SplitLayout>
      </div>
    </PageContainer>
  );
}

/** Employer portal and account settings: CodeField, Tables with danger actions, toggle ListRows. */
export const SettingsTemplate = SideNavTemplate;
/** Profile and CV Studio, application kits, interview kits. */
export const ProfileCvTemplate = SideNavTemplate;
